import {
  ComponentType,
  PropsWithChildren,
  ReactNode,
  useCallback,
  useState,
} from 'react';
import { DialogContext } from '../contexts';

type DialogProps = {
  view: ReactNode;
  id?: string;
  isOpen?: boolean;
};

type DialogsState = DialogProps[];

export type DialogContextType = {
  openDialog: (params: DialogProps) => void;
  closeDialog: () => void;
  dialogState: DialogsState;
  isLoading: boolean;
  setIsLoading: (isLoading: boolean) => void;
};

export const DialogProvider: ComponentType<PropsWithChildren> = ({
  children,
}) => {
  const [dialogState, setDialogState] = useState<DialogsState>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const openDialog = useCallback((dialogProps: DialogProps) => {
    setDialogState((prev) => [
      ...prev,
      {
        ...dialogProps,
        id: String(Date.now()),
      },
    ]);
  }, []);

  const closeDialog = useCallback(() => {
    setDialogState((prev) => {
      prev.pop();
      return [...prev];
    });
  }, []);

  return (
    <DialogContext.Provider
      value={{
        closeDialog,
        dialogState,
        openDialog,
        isLoading,
        setIsLoading,
      }}
    >
      {children}
    </DialogContext.Provider>
  );
};
